import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';

export const getSavedProjectReports = async (projectId, reportType) => {
  const apiPath = `report/project/${projectId}/type/${reportType}/get-reports`;

  const signedRequest = await createSignedGetRequest({
    apiPath,
  });

  const response = await axios(signedRequest);

  return response.data;
};
